export default "__VITE_ASSET__BbArTjGF__"